import { render, staticRenderFns } from "./account_add.vue?vue&type=template&id=c78dc62c&scoped=true&"
import script from "./account_add.vue?vue&type=script&lang=js&"
export * from "./account_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78dc62c",
  null
  
)

export default component.exports